import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from 'react-router-dom';
import QRCode from "react-qr-code";

import useCurrentProject from '@hooks/useCurrentProject';
import * as commonS from '@styles/common';
import MainContentHeader from '@components/MainContentHeader';
import Wrapper from '@components/Wrapper';

import * as S from './styles';

const QrCodeScreen = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { currentProject } = useCurrentProject();
  const [link, setLink] = useState('');
  useEffect(() => {
    if (currentProject?.type) setLink(`https://klassen-einteilung.herokuapp.com/${currentProject.type.toLowerCase()}/${params?.id}/add-student-form`);
  }, [currentProject])

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(link)
      .then(() => {
        toast.success('Copied!', { autoClose: 3000 })
      })
      .catch(err => {
        toast.error('Something went wrong!')
      });
  };

  return (
    <commonS.MainBody>
      {currentProject.type ?
        <>
        <MainContentHeader
          title={currentProject?.title}
          buttonTitle="Zu Projekten"
          onButtonClick={() => navigate('/projekte')}
        />
        <Wrapper
          headTitle="QR Code"
          onButtonClick={() => copyLinkToClipboard()}
          text='Copy Link'
        >
          <S.LinkItem>
            <Link to={`/${currentProject.type.toLowerCase()}/${params?.id}/add-student-form`}>{link}</Link>
          </S.LinkItem>
          <div style={{ height: "auto", margin: "auto", maxWidth: 320, width: "100%" }}>
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={link}
              viewBox={`0 0 256 256`}
            />
          </div>
        </Wrapper>
      </> : null}
    </commonS.MainBody>
  );
};

export default observer(QrCodeScreen);
